export default {
    "errorInesperado" : "Ocurrió un error, vuelve a intentarlo.",
    "errorPeticion" : "Ocurrió un error al realizar la peticion, vuelve a intentarlo.",
    "identificacionInvalida" : "El número de identificación es incorrecto, ingrese uno válido.",
    "archivo" : "Extensión de archivo incorrecto.",
    "fuenteIngreso" : "Debe ingresar al menos una de fuente de ingreso.",
    "referenciaFinanciera" : "Debe ingresar al menos una de referencia financiera.",
    "faltaArchivos" : "Debe subir todos los archivos solicitados.",
    "faltaInformación" : "Debe ingresar al menos un registro.",
    "correoAdministracion" : "Debe ingresar el correo para Administración General.",
    "corregirInformacion": "Debe ingresar la información correctamente.",
    "seleccionarProducto": "Debe seleccionar un producto.",
    "seleccionarCoberturasBasicas" : "Debe registrar las coberturas básicas que requiere para crear el plan.",
    "valorCoberturaIgualRango" : "El valor de cobertura debe ser igual al rango inicial.",
    "rangoIncorrecto" : "El rango inicial no puede ser mayor que el final.",
    "rangoFechaIncorrecto" : "El rango de fecha inicial no puede ser mayor al rango de fecha final.",
    "registroExistente" : "La información a ingresar ya se encuentra registrada.",
    "taMaximoArchivoPdf": "El archivo seleccionado sobrepasa el tamaño máximo establecido.",
    "beneficioExistente": "El beneficio complementario seleccionado ya se encuentra registrado.",
    "faltaIcono": "Debe seleccionar un ícono.",
    "faltaAutorizacion":"Debe seleccionar la autorización de los datos ingresados.",
    "coberturaNoIgual" : "Los datos de la plantilla a copiar deben ser los mismos de la plantilla seleccionada.",
    "datosNulos":"No se encontro información con los parametros de búsqueda."
}